module.exports = __webpack_public_path__ + "img/4.7ac540e6.png";